/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TpDialog.vue?vue&type=template&id=5bfb3d4f&"
import script from "./TpDialog.vue?vue&type=script&lang=js&"
export * from "./TpDialog.vue?vue&type=script&lang=js&"
import style0 from "./TpDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports